export const GetCommentsQueryKey = 'node-comments'
